export default {"src":"/_next/static/media/protection-blank-icon.0eb47587.svg","height":25,"width":22,"blurWidth":0,"blurHeight":0};